<template lang="pug">
.section
  .section-header
    h1 {{ $tc("ui.settings", 2) }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-body
            ul#setting.nav.nav-tabs(role='tablist')
              li.nav-item
                a#password-tab.nav-link.active(data-toggle='tab' href='#password-content' role='tab' aria-controls='slots' aria-selected='false') {{ $t("ui.password") }}
              //- li.nav-item
              //-   a#securitycode-tab.nav-link(data-toggle='tab' href='#securitycode-content' role='tab' aria-controls='security_code' aria-selected='true') {{ $t("ui.security_code") }}
            #settingcontent.tab-content.tab-bordered
              #password-content.tab-pane.active.show(role='tabpanel' aria-labelledby='password-tab')
                .card-group
                  changePwd
              //- #securitycode-content.tab-pane.fade(role='tabpanel' aria-labelledby='securitycode-tab')
              //-   .card-group
              //-     changeScrCode
</template>

<script>
import changePwd from "@/components/changePwd.vue";
import changeScrCode from "@/components/changeScrCode.vue";
// import changeGlobalSetting from "@/components/changeGlobalSetting.vue";
import config from "@/config";

export default {
  components: {
    changePwd,
    changeScrCode,
    // changeGlobalSetting
  },
  computed: {
    getAccountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountId == config.superUser;
    },
  }
};
</script>
